var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModalLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 60,
    viewBox: "0 0 59 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 60C4.83333 60 3.26389 59.3472 1.95833 58.0417C0.652778 56.7361 0 55.1667 0 53.3333V6.66667C0 4.83333 0.652778 3.26389 1.95833 1.95833C3.26389 0.652778 4.83333 0 6.66667 0H26.6667C27.6111 0 28.4028 0.319444 29.0417 0.958333C29.6806 1.59722 30 2.38889 30 3.33333C30 4.27778 29.6806 5.06944 29.0417 5.70833C28.4028 6.34722 27.6111 6.66667 26.6667 6.66667H6.66667V53.3333H26.6667C27.6111 53.3333 28.4028 53.6528 29.0417 54.2917C29.6806 54.9306 30 55.7222 30 56.6667C30 57.6111 29.6806 58.4028 29.0417 59.0417C28.4028 59.6806 27.6111 60 26.6667 60H6.66667ZM47.25 33.3333H23.3333C22.3889 33.3333 21.5972 33.0139 20.9583 32.375C20.3194 31.7361 20 30.9444 20 30C20 29.0556 20.3194 28.2639 20.9583 27.625C21.5972 26.9861 22.3889 26.6667 23.3333 26.6667H47.25L41 20.4167C40.3889 19.8056 40.0833 19.0556 40.0833 18.1667C40.0833 17.2778 40.3889 16.5 41 15.8333C41.6111 15.1667 42.3889 14.8194 43.3333 14.7917C44.2778 14.7639 45.0833 15.0833 45.75 15.75L57.6667 27.6667C58.3333 28.3333 58.6667 29.1111 58.6667 30C58.6667 30.8889 58.3333 31.6667 57.6667 32.3333L45.75 44.25C45.0833 44.9167 44.2917 45.2361 43.375 45.2083C42.4583 45.1806 41.6667 44.8333 41 44.1667C40.3889 43.5 40.0972 42.7083 40.125 41.7917C40.1528 40.875 40.4722 40.1111 41.0833 39.5L47.25 33.3333Z",
    fill: "url(#paint0_linear_403_3650)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_403_3650",
    x1: 10.8866,
    y1: -52.8,
    x2: 2.1199,
    y2: 42.9617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CEA6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F984F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalLogoutIcon);
export default __webpack_public_path__ + "static/media/modal-logout-icon.04efb99179755e4d0fd47cc67605307a.svg";
export { ForwardRef as ReactComponent };